import React, { Component } from 'react'
import { Row, Col, Icon, Modal } from 'antd';
import { firestoreConnect } from 'react-redux-firebase';
import { connect } from 'react-redux'
import { compose } from 'redux'
import { pathOr } from 'ramda';

class Footer extends Component {

  contactModal = () => {
    Modal.info({
      title: 'Contact Us',
      content: (
        <div>
          <p>Rivium Westlaan 8</p>
          <p>2909 LD Capelle aan den IJssel</p>
          <p>Nederland</p>
          <p>E-mail: info@unlocQed.nl</p>
          <p>Tel: +316 408 086 54</p>
        </div>
      )
    });
  }
  render() {
    const { company_count, users_candidate_count, job_posting_count, t } = this.props

    return (
      <Row>
        <Col span={24}>
          <div className="main-footer">
            <Col xs={{ span: 24, offset: 0 }} sm={{ span: 8, offset: 0 }} md={{ span: 8, offset: 0 }} lg={{ span: 6, offset: 2 }}>
              <div className="home-footer-heading">{t("TOTAL JOB OPENING")}</div>
              <div className="home-footer-count">{job_posting_count}</div>
            </Col>

            <Col xs={{ span: 24, offset: 0 }} sm={{ span: 8, offset: 0 }} md={{ span: 8, offset: 0 }} lg={{ span: 6, offset: 1 }}>
              <div className="verticalLineTwo"></div>
              <div className="home-footer-heading">{t("TOTAL NUMBER OF CANDIDATE")}</div>
              <div className="home-footer-count">{users_candidate_count}</div>
            </Col>

            <Col xs={{ span: 24, offset: 0 }} sm={{ span: 8, offset: 0 }} md={{ span: 8, offset: 0 }} lg={{ span: 6, offset: 1 }}>
              <div className="verticalLine"></div>
              <div className="home-footer-heading">{t("TOTAL COMPANIES")}</div>
              <div className="home-footer-count">{company_count}</div>
            </Col>
          </div>
        </Col>
        <Col span={24}>
          <div className="main-footer">
            <Col sm={{ span: 24}} md={{ span: 12, offset: 0 }} className="footer-left">
              <a target="_blank" href="/statements/unlocQed_Privacy_Statement.pdf"><div className="home-footer-nav">{t("Privacy Policy")}</div></a>
              <div className="home-footer-nav" onClick={this.contactModal}>{t("Contact")}</div>
              {/* <div className="home-footer-nav">{t("terms_and_conditions")}</div> */}
            </Col>
            {/* <Col xs={{ span: 0, offset: 0 }} sm={{ span: 0, offset: 0 }} md={{ span: 2, offset: 0 }} lg={{ span: 0, offset: 0 }}></Col> */}
            <Col sm={{ span: 24, offset: 0 }} md={{ span: 12, offset: 0 }} className="footer-right">
              <div className="home-footer-social" style={{marginRight: 20}}>
                <a target="_blank" href="https://www.instagram.com/unlocqed/">
                  <Icon style={{ fontSize: '48px', color: "#4D77F8" }} type="instagram" theme="filled" />
                </a>
              </div>
              <div className="home-footer-social" style={{marginRight: 20}}>
                <a target="_blank" href="https://www.facebook.com/UnlocQed-111850093521591">
                  <Icon style={{ fontSize: '48px', color: "#4D77F8" }} type="facebook" theme="filled" />
                </a>
              </div>
              <div className="home-footer-social" style={{marginRight: 10}}>
                <a target="_blank" href="https://www.linkedin.com/company/unlocqed/about/">
                  <Icon style={{ fontSize: '48px', color: "#4D77F8" }} type="linkedin" theme="filled" />
                </a>
              </div>
            </Col>
          </div>
        </Col>
      </Row>
    )
  }
}

const enhancer = compose(
  firestoreConnect(() => {
    return [
      {
        collection: 'users',
        where: [
          ['role', '==', 'candidate']
        ],
        storeAs: 'users_candidate_count'
      },
      {
        collection: 'company',
        storeAs: 'company_count'
      },
      {
        collection: 'job_posting',
        where: [
          ['status', '==', 1]
        ],
        storeAs: 'job_posting_count'
      },
    ]
  }),
  connect((state, props) => {
    const { data } = state.firestore
    return {
      company_count: Object.keys(pathOr(0, ['company_count'], data)).length,
      users_candidate_count: Object.keys(pathOr(0, ['users_candidate_count'], data)).length,
      job_posting_count: Object.keys(pathOr(0, ['job_posting_count'], data)).length
    }
  }),
)

export default enhancer(Footer)
